import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/slice';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import React__default from 'react';
import { api, format } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import '../../../emotes/emote-panel.js';
import { useEmotes } from '../../../emotes/hooks/use-emotes.js';
import { useComment } from '../hooks/use-comment.js';
import { useLike } from '../hooks/use-like.js';
import { getProfileUrl, formatCommentTime, formatLikeCount, formatComment, isCommentContainingUserAt } from '../utils.js';

function formatRemainingComments(remainingComments) {
  var NUM_TO_START_TRUNCATE = 10000;

  if (remainingComments < NUM_TO_START_TRUNCATE) {
    return "\u8FD8\u6709 ".concat(remainingComments, " \u6761\u56DE\u590D\uFF0C\u70B9\u51FB\u67E5\u770B");
  }

  var truncatedNumber = format.formatCount(remainingComments, {
    limit: NUM_TO_START_TRUNCATE,
    suffix: ' 万',
    type: format.EFormatCountType.Down
  });
  return "\u8FD8\u6709 ".concat(truncatedNumber, "\u6761\u56DE\u590D\uFF0C\u70B9\u51FB\u67E5\u770B");
}

var SubCommentWithMeta = function SubCommentWithMeta(_ref) {
  var subComment = _ref.subComment,
      onClickingContent = _ref.onClickingContent;
  var userid = subComment.userid,
      username = subComment.username,
      ctime = subComment.ctime,
      ip_location = subComment.ip_location;

  var _useEmotes = useEmotes(),
      formatEmotes = _useEmotes.formatEmotes;

  return /*#__PURE__*/React__default.createElement("li", {
    className: "sub-comment"
  }, /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: getProfileUrl(userid),
    className: "username"
  }, username), /*#__PURE__*/React__default.createElement("div", {
    className: "comment-time"
  }, formatCommentTime(ctime), ip_location ? " \xB7 ".concat(ip_location) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: "comment-content",
    onClick: function onClick(e) {
      if (e.target.classList.contains('username')) {
        return;
      }

      onClickingContent === null || onClickingContent === void 0 ? void 0 : onClickingContent();
    },
    dangerouslySetInnerHTML: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __html: formatEmotes(formatComment(subComment), subComment.ctime)
    }
  }));
};

var SubCommentsWithoutMeta = function SubCommentsWithoutMeta(_ref2) {
  var subComment = _ref2.subComment,
      onClickingContent = _ref2.onClickingContent;
  var userid = subComment.userid,
      username = subComment.username,
      comment_content = subComment.comment_content;

  var _useEmotes2 = useEmotes(),
      formatEmotes = _useEmotes2.formatEmotes;

  var isContainingUserAt = isCommentContainingUserAt(comment_content);
  return /*#__PURE__*/React__default.createElement("li", {
    className: "sub-comment-without-meta"
  }, /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: getProfileUrl(userid),
    className: "username"
  }, username), isContainingUserAt ? ' ' : '：', /*#__PURE__*/React__default.createElement("span", {
    className: "comment-content",
    onClick: function onClick(e) {
      if (e.target.classList.contains('username')) {
        return;
      }

      onClickingContent === null || onClickingContent === void 0 ? void 0 : onClickingContent();
    },
    dangerouslySetInnerHTML: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __html: formatEmotes(formatComment(subComment), subComment.ctime)
    }
  }));
};

var CommentItem = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _context2;

  var onToggleReply = props.onToggleReply,
      type = props.type,
      onLike = props.onLike,
      _props$subCommentsCon = props.subCommentsConfig,
      subCommentsConfig = _props$subCommentsCon === void 0 ? {} : _props$subCommentsCon;

  var _useEmotes3 = useEmotes(),
      formatEmotes = _useEmotes3.formatEmotes;

  var _useComment = useComment(props.comment, {
    subCommentMode: 'infinite'
  }),
      _useComment2 = _slicedToArray(_useComment, 2),
      comment = _useComment2[0],
      _useComment2$ = _useComment2[1],
      loadSubCommentsOfNextPage = _useComment2$.loadSubCommentsOfNextPage,
      insertSubComment = _useComment2$.insertSubComment; // NOTE: 移动端暂不支持对子评论点赞


  var _useLike = useLike(props.comment, false),
      _useLike2 = _slicedToArray(_useLike, 2),
      _useLike2$ = _useLike2[0],
      numLikes = _useLike2$.numLikes,
      likeState = _useLike2$.likeState,
      like = _useLike2[1].like;

  var userid = comment.userid,
      icon = comment.icon,
      username = comment.username,
      ctime = comment.ctime,
      id = comment.id,
      ip_location = comment.ip_location,
      totalSubComments = comment.sub_comment_num,
      subComments = comment.subComments;
  React__default.useImperativeHandle(ref, function () {
    return {
      insertSubComment: insertSubComment
    };
  });

  var handleClickExpand = function handleClickExpand() {
    loadSubCommentsOfNextPage();
  };

  var handleLike = function handleLike() {
    if (onLike) {
      onLike(comment);
      return;
    }

    like();
  };

  var handleClickCommentContent = function handleClickCommentContent(usernameToReply) {
    onToggleReply(id, usernameToReply);
  };

  var profileUrl = getProfileUrl(userid);

  var renderSubComments = function renderSubComments() {
    var _context;

    if (!subComments.comments || subComments.comments.length === 0) {
      return null;
    }

    var maxNumEntries = subCommentsConfig.maxNumEntries,
        disableMeta = subCommentsConfig.disableMeta;
    var realSubComments = maxNumEntries ? _sliceInstanceProperty(_context = subComments.comments).call(_context, 0, maxNumEntries) : subComments.comments;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "sub-comments"
    }, /*#__PURE__*/React__default.createElement("ul", null, _mapInstanceProperty(realSubComments).call(realSubComments, function (subComment) {
      return disableMeta ? /*#__PURE__*/React__default.createElement(SubCommentsWithoutMeta, {
        key: subComment.id,
        subComment: subComment,
        onClickingContent: function onClickingContent() {
          return handleClickCommentContent(subComment.username);
        }
      }) : /*#__PURE__*/React__default.createElement(SubCommentWithMeta, {
        key: subComment.id,
        subComment: subComment,
        onClickingContent: function onClickingContent() {
          return handleClickCommentContent(subComment.username);
        }
      });
    })), !maxNumEntries && subComments.comments.length < totalSubComments && /*#__PURE__*/React__default.createElement("button", {
      className: "expand-comment",
      onClick: handleClickExpand
    }, formatRemainingComments(totalSubComments - subComments.comments.length)));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    id: _concatInstanceProperty(_context2 = "".concat(type ? "".concat(type, "-") : '', "comment-")).call(_context2, id),
    className: "comment"
  }, /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: profileUrl,
    className: "avatar"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: username,
    src: api.removeUrlProtocol(icon)
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "comment-body"
  }, /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: profileUrl,
    className: "username"
  }, username), /*#__PURE__*/React__default.createElement("div", {
    className: "comment-time"
  }, formatCommentTime(ctime), ip_location ? " \xB7 ".concat(ip_location) : ''), /*#__PURE__*/React__default.createElement("div", {
    className: classNames('comment-like', {
      active: likeState === 'liked'
    }),
    onClick: handleLike
  }, formatLikeCount(numLikes)), /*#__PURE__*/React__default.createElement("div", {
    className: "comment-content",
    onClick: function onClick() {
      return handleClickCommentContent(username);
    },
    dangerouslySetInnerHTML: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __html: formatEmotes(formatComment(comment), comment.ctime)
    }
  }), renderSubComments()));
});

export { CommentItem };
